import { render, staticRenderFns } from "./EntityDetailSidebarCard.vue?vue&type=template&id=6f29f41f&scoped=true"
import script from "./EntityDetailSidebarCard.vue?vue&type=script&lang=ts"
export * from "./EntityDetailSidebarCard.vue?vue&type=script&lang=ts"
import style0 from "./EntityDetailSidebarCard.vue?vue&type=style&index=0&id=6f29f41f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f29f41f",
  null
  
)

export default component.exports